import { Button, Modal } from "react-bootstrap"
import List, { ListName } from "../List/List";
import { fetchData } from "../List/ListFuncs";
import { MortgageLenderItem } from "./MortgageLenderTypes";
import { LenderLinkType } from "./MortgageLenderLink";
import { ListDefine } from "../ThirdPartyList/ThirdPartyComponent";

type selectMortgageType = {
    listName: ListName;
    closeFunc: (selectLenderCode:boolean) => void,
    setLenderField: (selectLenderCodeName: string) => void,
    fieldType: string,
}

function buildLenderNamesLink(
    setField?: (lenderName: string) => void,
    closeFunc?: (close: boolean) => void,
    fieldType?: string,
) {
    return (LenderEntry: MortgageLenderItem) => {
        return (
            <LenderNamesLink
                LenderEntry={LenderEntry}
                typeLender={"Mortgage_lender"}
                key={`${LenderEntry['Name']}`}
                setField={setField}
                closeFunc={closeFunc}
                fieldType={fieldType}
            />
        )
    }
}

const LenderNamesLink = (props: LenderLinkType) => {
    return (
        <>
            {(props.fieldType === "Code" && props.LenderEntry['LenderProgramID'] != null && props.LenderEntry['LenderProgramID'] > "") &&
                <tr>
                    <td></td>
                    <td onClick={() => {
                        props.setField(props.LenderEntry['LenderProgramID']);
                        props.closeFunc(false);
                    }}>
                        {props.LenderEntry['Name']}
                    </td>
                </tr>
            }
        </>
    )
}

export const SelectLenderFieldList = (props: selectMortgageType) => {
    const listDef = ListDefine[props.listName].Sublists[0];
    return (
        <Modal className="modal-list modal-search" centered show={true} size="xl">
            <Modal.Body>
                <List
                    listName={props.listName}
                    handleLoadQpickData={fetchData}
                    ListColumns={listDef.fileListColumns}
                    buildHead={listDef.buildHead}
                    buildLenderListLink={buildLenderNamesLink}
                    searchTable={listDef.searchTable}
                    setLenderName={props.setLenderField}
                    closeFunc={props.closeFunc}
                    fieldType={props.fieldType}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => { props.closeFunc(false); }}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}